import "jquery/dist/jquery.min.js";
import $ from "jquery";
import { msalAuth } from "../../api/msal/MsalAuthProvider";
import * as omnimap from "../../api/omnimap/omnimapActions";
import { useState } from "react";

export default function standart() {}

var returnData = {
  treeList: [],
  treecount: null,
};

export const StartActivity = async (
  model,
  selection,
  activity_id,
  success_callback,
  token
) => {
  var url =
    "https://" +
    process.env.REACT_APP_BASE_URL +
    "/omnimap/instances/flow/" +
    activity_id +
    "/start?instance_identification=" +
    selection.join(",");
  //start ajax
  $.ajax({
    type: "POST",
    url: url,
    beforeSend: function (request) {
      request.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("accessToken"));
      request.setRequestHeader(
        "tenant_identification",
        process.env.REACT_APP_TENANT_IDENTIFICATION
      );
      request.setRequestHeader(
        "organisation_identification",
        process.env.REACT_APP_ORGANISATION_IDENTIFICATION
      );
    },
    contentType: "application/json",
    dataType: "json",
    async: false,
    success: function (result) {
      sleep(500).then(() => {
        PostActivity(model, selection, activity_id, success_callback, token);
      });
    },
    error: function () {
      alert("Error retrieving column data");
    },
  });
};

export const PostActivity = (
  model,
  selection,
  activity_id,
  success_callback,
  token
) => {
  var url =
    "https://" +
    process.env.REACT_APP_BASE_URL +
    "/omnimap/instances/flow/" +
    activity_id +
    "/activity/inputdata?instance_identification=" +
    selection.join(",");

  //start ajax
  $.ajax({
    type: "POST",
    url: url,
    beforeSend: function (request) {
      request.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("accessToken"));
      request.setRequestHeader(
        "tenant_identification",
        process.env.REACT_APP_TENANT_IDENTIFICATION
      );
      request.setRequestHeader(
        "organisation_identification",
        process.env.REACT_APP_ORGANISATION_IDENTIFICATION
      );
    },
    contentType: "application/json",
    dataType: "json",
    data: JSON.stringify(model),
    async: false,
    success: success_callback,
    error: function () {
      alert("fail");
    },
  });
};

export const FormatDate = (date, type) => {
  var d = new Date(date);
  var month = (d.getMonth() + 1).toString();
  var day = d.getDate().toString();
  var year = d.getFullYear();
  var hour = d.getHours().toString();
  var minute = d.getMinutes().toString();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (hour.length < 2) hour = "0" + hour;
  if (minute.length < 2) minute = "0" + minute;

  if (type == "daymonth") return [day, month].join("-");
  if (type == "date") return [day, month, year].join("-");
  else if (type == "withTime")
    return [day, month, year].join(".") + " " + [hour, minute].join(":");
  else if ((type = "yyyyMMdd"))
    return [year, month, day].join("/") + " " + [hour, minute].join(":");
};

export const FormatDateReverse = (date, type) => {
  var d = new Date(date);
  var month = (d.getMonth() + 1).toString();
  var day = d.getDate().toString();
  var year = d.getFullYear();
  var hour = d.getHours().toString();
  var minute = d.getMinutes().toString();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (hour.length < 2) hour = "0" + hour;
  if (minute.length < 2) minute = "0" + minute;

  if (type == "date") return [year, month, day].join("-");
  else if (type == "withTime")
    return [year, month, day].join("/") + " " + [hour, minute].join(":");
  else if ((type = "yyyyMMdd"))
    return [year, month, day].join("/") + " " + [hour, minute].join(":");
};

export const curday = function (sp) {
  let today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //As January is 0.
  var yyyy = today.getFullYear();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  return yyyy + sp + mm + sp + dd;
};

export const epoch = () => {
  const now = new Date();
  return Math.round(now.getTime() / 1000);
};

export function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

// saf json'nı tree yapısı haline getiren fonksiyon
export const list_to_tree = (list) => {
  var map = {},
    node,
    roots = [],
    i;
  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i;
    list[i].children = [];
  }
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parentfolder !== "0" && node.parentfolder !== undefined) {
      list[map[node.parentfolder]].children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
};

// saf json'nı tree yapısı haline getiren fonksiyon
// ?aynı zamanda modelide içinde barındırıp serivise istekte bulunur.
export function GetTreeStructure(list, model, token, isUpdate, url) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: url
        ? url
        : "https://" +
          process.env.REACT_APP_BASE_URL +
          "/omnimap/search/?page-size=1000&page-number=1&includes=PROPERTIES,MONITORING,CONTENT,CONTEXT",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("accessToken"));
        request.setRequestHeader(
          "tenant_identification",
          process.env.REACT_APP_TENANT_IDENTIFICATION
        );
        request.setRequestHeader(
          "organisation_identification",
          process.env.REACT_APP_ORGANISATION_IDENTIFICATION
        );
      },
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(model),
      success: function (result) {
        var data = result.data;
        if (data !== undefined) {
          // console.log(data);
          list = [];
          for (let i = 0; i < data.length; i++) {
            list.push({
              name: data[i].name,
              id: data[i].identification,
              isSubfolder: data[i].content["algemeen-issubfolder"],
              parentfolder: data[i].content["algemeen-parentfolder"],
              children: null,
            });
          }

          if (!isUpdate) {
            returnData.treeList = list_to_tree(list, 0);
            resolve(returnData);
          } else {
            returnData.treeList = list_to_tree(list, 0);
            returnData.treecount = list.length;
            resolve(returnData);
          }
        } else {
          returnData.treeList = [];
          returnData.treecount = 0;
          resolve(returnData)
        }
      },
      error: function (err) {
        console.log("errror");
      },
    });
  });
}

// saf tree yapısının geri dönüşünü sağlar.
export function GetTreeStructurePure(list, model, token, isUpdate, url) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: url
        ? url
        : "https://" +
          process.env.REACT_APP_BASE_URL +
          "/omnimap/search/?page-size=1000&page-number=1&includes=PROPERTIES,MONITORING,CONTENT,CONTEXT",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("accessToken"));
        request.setRequestHeader(
          "tenant_identification",
          process.env.REACT_APP_TENANT_IDENTIFICATION
        );
        request.setRequestHeader(
          "organisation_identification",
          process.env.REACT_APP_ORGANISATION_IDENTIFICATION
        );
      },
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(model),
      success: function (result) {
        var data = result.data;
        if (data != undefined) {
          // console.log(data);
          list = [];
          for (let i = 0; i < data.length; i++) {
            list.push({
              name: data[i].name,
              id: data[i].identification,
              isSubfolder: data[i].content["algemeen-issubfolder"],
              parentfolder: data[i].content["algemeen-parentfolder"],
              children: null,
            });
          }

          resolve(list);
        } else resolve(undefined);
      },
      error: function (err) {
        console.log("errror");
      },
    });
  });
}

export function FAddfolder(model, token) {
  return new Promise(function (resolve, reject) {
    var url =
      "https://" +
      process.env.REACT_APP_BASE_URL +
      "/omnimap/generic/instances/";
    /** Start Ajax */
    $.ajax({
      type: "POST",
      url: url,
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("accessToken"));
        request.setRequestHeader(
          "tenant_identification",
          process.env.REACT_APP_TENANT_IDENTIFICATION
        );
        request.setRequestHeader(
          "organisation_identification",
          process.env.REACT_APP_ORGANISATION_IDENTIFICATION
        );
      },
      contentType: "application/json",
      dataType: "json",
      async: false,
      data: JSON.stringify(model),
      success: function (data) {
        if ((data.result.status = "OK")) {
          resolve(true);
        } else {
          resolve(false);
        }
      },
      error: function () {
        //alert("Error retrieving column data");
      },
    });
  });
}

// yeni token isteğinde bulunan fonksiyon
export async function GetToken() {
  return new Promise(async function (resolve, reject) {
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            resolve(response.idToken.rawIdToken);
            window.$catalog_management_units_token =
              response.idToken.rawIdToken;
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenRedirect(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            window.$catalog_management_units_token =
              response.idToken.rawIdToken;
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }
    }
  });
}

// zamanı utc modundan geri dönüşünü sağlar
export function GetDateTimeNow() {
  var currentdate = new Date();

  // if the value is less than 10 apply condition
  let second =
    currentdate.getSeconds() < 10
      ? "0" + currentdate.getSeconds()
      : currentdate.getSeconds();

  // if the value is less than 10 apply condition
  let hour =
    currentdate.getHours() < 10
      ? "0" + currentdate.getHours()
      : currentdate.getHours();

  // if the value is less than 10 apply condition
  let date =
    currentdate.getDate() < 10
      ? "0" + currentdate.getDate()
      : currentdate.getDate();
  // if the value is less than 10 apply condition

  let month =
    currentdate.getMonth() + 1 < 10
      ? "0" + (currentdate.getMonth() + 1)
      : currentdate.getMonth() + 1;
  // if the value is less than 10 apply condition

  let minute =
    currentdate.getMinutes() < 10
      ? "0" + currentdate.getMinutes()
      : currentdate.getMinutes();
  // if the value is less than 10 apply condition

  let milliseconds =
    currentdate.getMilliseconds() < 10
      ? "0" + currentdate.getMilliseconds()
      : currentdate.getMilliseconds();

  // return datatime value of utc format
  let datetime =
    currentdate.getFullYear() +
    "-" +
    month +
    "-" +
    date +
    "T" +
    hour +
    ":" +
    minute +
    ":" +
    second +
    "." +
    milliseconds +
    "Z";
  return datetime;
}

export function GetEntityList(
  def,
  pageNr,
  pageSize,
  successCallback,
  token,
  contentModel
) {
  var content = [
    {
      key: "algemeen-actief",
      and_or: "AND",
      values: [true],
      datatype: "BOOLEAN",
    },
  ];
  if (contentModel !== undefined) {
    content.push(contentModel);
  }

  var model = {
    content: content,
    definitions: [def],
  };

  omnimap
    .GetEntityListAction(model, pageNr, pageSize, token)
    .then(successCallback);
}

// Tree yapısını düz array haline getiren fonksiyon.
export function TreeResolve(tree, output = []) {
  for (let i = 0; i < tree.length; i++) {
    var node = tree[i];
    output.push(node);
    if (node.children.length > 0) {
      TreeResolve(node.children, output);
    }
  }
  return output;
}

export const CodeAutoFill = (prefix) => {
  return `${prefix}_${curday("_")}_${epoch()}`;
};

export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getUserProfile() {
  let userRaw = window.localStorage.getItem("currentUser");
  return JSON.parse(userRaw);
}

// kullanıcı rolüne göre action listleri döner
export const GetActionListByUserRole = async (referenceId, token, user) => {
  const stage_identification = [];

  // const allUser = await omnimap.GetAllUsersAction(
  //   1,
  //   100,
  //   "",
  //   "",
  //   "",
  //   "",
  //   token
  // );
  // let userRoles = allUser.data.find((x) => x.alias === user.name).relationships
  //   .roles;
  
  
  // kullanıcın tüm profil bilgilerini ve yetkilerini getirir.
  let userRoles = await getUserProfile();
  userRoles = userRoles? userRoles.data.relationships.roles: []
  let actionListByRole = await omnimap.GetActionListByRoleAction(
    referenceId,
    token
  );
  actionListByRole = actionListByRole.data.data.bulk_actions;

  actionListByRole.forEach((bulk) => {
    bulk.security_context.forEach((security) => {
      security.application_roles.forEach((applicationRole) => {
        // id "*" as looks like means no security limitation
        if(applicationRole === "*"){
          stage_identification.push(bulk.stage_identification)
        } else {
          userRoles.forEach((userRole) => {
            if (applicationRole === userRole.role.identification) {
              stage_identification.push(bulk.stage_identification);
            }
          });
        }
      });
    });
  });
  var unique = [
    ...new Set(
      stage_identification && stage_identification.map((item) => item)
    ),
  ];
  return unique;
};

/////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
//action status control

/**
 * * çalıştırılan process'lerin durumları burada takip ediliyor.
 * @param {* hangi action çalıştırılmışsa o actionın ismi}  definitionName
 * @param {* hangi action çalıştırılmışsa o actionın id'si} definitionId
 * @var   {* seçili tüm satrıların staglist'leri barındıran dizi} selectedRowDefinition
 */
var successControlList = [];
var errorRowList = [];
var successRowCount = 0;
var errorRowCount = 0;
var completeSuccess = false;
var completeError = false;
export const waitProcess = async (
  definitionName = null,
  definitionId = null,
  selectedRowDefinition,
  context,
  _successRowCount
) => {
  /**
   * * seçili tüm satrıların staglist'leri burada işleniyor
   */
  successRowCount = await _successRowCount;
  errorRowCount = await 0;
  errorRowList = await [];

  for (let i = 0; i < selectedRowDefinition.length; i++) {
    const rowItem = selectedRowDefinition[i];

    // burada her statırın stagelist'i içerisindeki şuan çalıştırılan action aranıyor
    // ve id'si fonksiyona aktarılıyor.
    for (let j = 0; j < rowItem.stageList.length; j++) {
      const stage = rowItem.stageList[j];
      if (
        stage.definition.name == definitionName ||
        stage.definition.identification == definitionId
      ) {
        await waitRecursiveControl(
          stage.identification,
          rowItem.id,
          rowItem.rowItem.werkplanNaam,

          context
        ).then((result) => {
          /**
           * * fonsiyonun devamında hangi işlemlerin yapılacağı butaya yazılacak.
           */
          console.log(result);
        });
      }
    }
  }
};

const waitRecursiveControl = async (
  activityId,
  rowId,
  werkplanNaam,
  context
) => {
  return new Promise(async (resolve) => {
    sleep(1500).then(async () => {
      await omnimap
        .GetRowOfActionDetailStartAction(
          rowId,
          activityId,
          window.$mm_management_units_token
        )
        .then((stageResult) => {
          /**
           * *   1. ihtimal tamamlanması
           * *     "state": "FINISHED", durumu başarılıolarak işlemin bittiğini açıklıyor
           * * omnimaptaki senaryoya göre stagesListe şuanki işlem yaptığımız activite olan "Verwijder uit uitvoering" id'sinin listede olmamasıdır
           */
          if (
            (stageResult.data && stageResult.data.state == "CANCELLED") ||
            stageResult.data.state == "FINISHED"
          ) {
            successRowCount--;
            context.actions.actionStartProcess({
              successRowCount: successRowCount,
              errorRowCount: errorRowCount,
              completeSuccess: true,
              completeError: completeError,
            });
            resolve(true);
          } else if (
            /**
             * *   2. ihtimal devam ediyor olması
             * * eğer işlem yeni başlamışsa fonskiyon yeniden çağrılıyor.
             */
            stageResult.data &&
            stageResult.data.state == "STARTED"
          ) {
            resolve(
              waitRecursiveControl(activityId, rowId, werkplanNaam, context)
            );
          } else if (
            /**
             * *   3. ihtimal işlemin hata ile sonuçlanması.
             */
            stageResult.data &&
            stageResult.data.state == "FAILED"
          ) {
            errorRowCount++;
            // let errorRowList = context.storeProcess.errorRowCodes;
            errorRowList.push(werkplanNaam + " : " + stageResult.data["state_description"]);
            context.actions.actionStartProcess({
              successRowCount: successRowCount,
              errorRowCount: errorRowCount,
              completeSuccess: false,
              completeError: true,
              errorRowCodes: errorRowList,
            });
            resolve(true);
          }
        });
    });
  });
};
